import { render, staticRenderFns } from "./ShowApplicationDetails.vue?vue&type=template&id=87654b02&scoped=true"
import script from "./ShowApplicationDetails.vue?vue&type=script&lang=js"
export * from "./ShowApplicationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87654b02",
  null
  
)

export default component.exports